import { isDesktopRuntime } from '@/desktop/desktopDetection';
import { lazyOverlay } from '@/routing/lazyRoute';

const LazyPrompt = lazyOverlay(
  () => import('./MacAddressConsentPrompt'),
  (module) => module.MacAddressConsentPrompt,
);

/**
 * T-0559: the Mac app's one-time question, its own chunk. A browser never asks it, so a browser never
 * fetches it: only the desktop shell loads the code, after the first paint.
 */
export function MacAddressConsentPrompt() {
  return isDesktopRuntime() ? <LazyPrompt /> : null;
}
